import React from "react"
import { activitySEO } from "../../../constants/activity-constants"

import "./modal-endgame.scss"

export default function ModalEndGame(props) {
  const { totalPoints, handleSuccess } = props

  const goTop = () => {
    window.location.href = `${activitySEO.url}/top`
  }

  return (
    <div className="modal-endgame">
      <div className="modal-endgame-container">
        <div className="wrapper-star">
          <h2 className="wrapper-star__title">
            <span className="family-TrashHand size-44 color-blue">Wowwww</span>
          </h2>
          <div className="wrapper-star__body">
            <p className="family-H-Bold size-20 color-blue">
              ¡Lo lograste! Ganaste{" "}
              <span className="color-pink-heavy">{totalPoints}</span> puntos.
              ¿Quieres ver si estás entre los mejores puntajes?{" "}
              <a onClick={goTop} className="color-pink-heavy underline">
                Haz clic aquí
              </a>
            </p>
            <button
              className="btn-primary f-concentrate-modal-endgame-btn"
              onClick={() => {
                handleSuccess()
              }}
            >
              VOLVER A JUGAR
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
